import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { storesContext } from '../../stores/storesContext';

const BlockButtons = ({ selectedBlockId, onClick, disabled, actions }) => {
  const userStore = useContext(storesContext);
  const alcmStore = userStore.alcmStore;

  return (
    <div
      className='d-flex flex-wrap justify-content-center'
      style={{ gap: '0.5rem' }}
    >
      <div className='mr-1'>
        {alcmStore.monitoringBlocks.map((mb) => (
          <Button
            key={mb.id}
            variant={selectedBlockId === mb.id ? 'success' : 'outline-success'}
            className='mx-1 px-3'
            onClick={() => onClick(mb)}
            disabled={disabled}
          >
            {mb.block_id}
          </Button>
        ))}
      </div>
      {actions && <div>{actions}</div>}
    </div>
  );
};

export default observer(BlockButtons);

